/* eslint-disable @typescript-eslint/no-explicit-any */
import type { DocNode as ADF } from '@atlaskit/adf-schema';
import { defaultSchema as schema } from '@atlaskit/adf-schema/schema-default';
import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import { WikiMarkupTransformer } from '@atlaskit/editor-wikimarkup-transformer';

export const convertWikiToADF = (wiki: string): ADF => {
	if (wiki === undefined) {
		return {
			version: 1,
			type: 'doc',
			content: [],
		};
	}
	const adfTransformer = new JSONTransformer();
	const wikiMarkupTransformer = new WikiMarkupTransformer(schema);

	const pmNode = wikiMarkupTransformer.parse(wiki);
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return adfTransformer.encode(pmNode) as ADF;
};

export const isAdfObject = (field: any) => {
	return field && field.type === 'doc' && Array.isArray(field.content);
};

export const getRichTextFieldValue = (defaultValue: unknown) => {
	if (Array.isArray(defaultValue) && defaultValue.length > 0) {
		if (typeof defaultValue[0] === 'string' || typeof defaultValue[0] === 'number')
			return convertWikiToADF(defaultValue[0].toString());
		if (isAdfObject(defaultValue[0])) return defaultValue[0];
	}
	if (typeof defaultValue === 'string' || typeof defaultValue === 'number') {
		// for connect we expect a simple string to be passed
		return convertWikiToADF(defaultValue.toString());
	}
	if (isAdfObject(defaultValue)) return defaultValue;
	return null;
};
